<template>
    <button class="button navigation" type="button">
        <span class="icon arrow-back" />
        <span class="hide-android">
            <slot>Terug</slot>
        </span>
    </button>
</template>
